/* ==========================================================================
   GENA — Synchronisation de l'icone des accordeons          (02/10/2026)
   --------------------------------------------------------------------------
   LE PROBLEME
   Les accordeons de la fiche produit sont exclusifs via l'attribut HTML natif
   `name` : ouvrir l'un ferme l'autre, sans JS. Mais le theme pose
   `aria-expanded` au rendu Liquid et ne le met a jour que sur l'element
   CLIQUE. Celui que le navigateur ferme tout seul garde `aria-expanded="true"`.

   Or c'est `aria-expanded` qui pilote l'icone : .animated-plus affiche un +,
   et passe au - quand l'ancetre .group porte aria-expanded="true". Resultat :
   un accordeon ferme continuait d'afficher un -.

   LA CORRECTION
   On ecoute `toggle`, qui se declenche AUSSI sur la fermeture automatique, et
   on recopie `open` dans `aria-expanded`. Cinq lignes, et ca vaut pour tous
   les accordeons du site, pas seulement la fiche produit.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__genaAccordionSync) return;
  window.__genaAccordionSync = true;

  function sync(d) {
    d.setAttribute('aria-expanded', d.open ? 'true' : 'false');
  }

  function bind(root) {
    (root || document).querySelectorAll('details.accordion__disclosure').forEach(function (d) {
      if (d.dataset.genaSync === '1') return;
      d.dataset.genaSync = '1';
      sync(d);
      d.addEventListener('toggle', function () { sync(d); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();

  // l'editeur de theme re-rend les sections sans recharger la page
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
